import React, { Component } from 'react'
import Phone from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import './phone.css'
import { translate } from "react-i18next"

class InputPhone extends Component {
  constructor(props){
    super(props)

    this.state = {
      value: (props.value !== null && props.value !== undefined) ? props.value : '',
      error: false,
      country: props.countryCode,
    }

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validate = this.validate.bind(this)
    this.handleCountryChanged = this.handleCountryChanged.bind(this)
  }

  componentWillReceiveProps(nextProps){
    const { value } = nextProps
    this.setState({
      value: (value !== null && value !== undefined) ? value : ''
    })
    this.focusInput()
  }
  componentDidMount() {
    this.focusInput()
  }
  componentDidUpdate(prevProps, prevState) {
    this.focusInput()
  }

  focusInput() {
    const element = document.querySelector('.PhoneInput')
    if (element) {
      element.focus()
    }
  }

  handleSubmit(){
    if(this.props.onSubmit && this.validate()){
      if(this.state.country === "CW") {
        // Fix for Curacao country code.
        // There doesn't seem to be a way of customising it in the library we are using
        this.props.onSubmit(this.state.value.replace(/^\+599/gi, '+5999'))
        return
      }
      this.props.onSubmit(this.state.value)
    } else {
      this.setState({ error: true })
      setTimeout(() => { this.setState({ error: false }) }, 500)
    }
  }

  validate(){
    const { value } = this.state
    const { required } = this.props
    const regex = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/g

    if( !value || value.length === 0 ) {
      return !required
    }

    return regex.test(value)
  }

  handleCountryChanged(country){
    this.setState({ country })
  }

  handleInputChange(value){
    this.setState({ value })
  }

  handleKeyDown(e){
    if( e.keyCode === 13 ) { // Enter
      e.preventDefault()
      this.handleSubmit()
    }
  }

  render() {
    let { color, countryCode, t } = this.props

    return (
      <div className="booking-input booking-input-text inside-button">
        <div className={`booking-input-wrapper ${ this.state.error ? 'shake' : '' }`}>
          <Phone
            placeholder={ t("mobile-phone-placeholder") }
            value={ this.state.value }
            onChange={this.handleInputChange}
            onKeyDown={this.handleKeyDown}
            defaultCountry={countryCode}
            onCountryChange={this.handleCountryChanged}
            flagUrl="https://cogsworth-static-apps.s3.eu-west-1.amazonaws.com/misc/country-flags/{XX}.svg"
          />

          <button onClick={this.handleSubmit} style={{ backgroundColor: color }}>{this.props.okButtonLabel}</button>
        </div>
      </div>
    );
  }
}

export default translate("translations")(InputPhone)
